import {html, nothing} from 'lit';
import componentStyles from './iframe-popup.css.lit.ts';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';

export default class IframePopup extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      buttonText: { type: String },
      url: { type: String },
    }
  }

  constructor() {
    super();
    this.buttonText = '';
    this.url = '';
    window.addEventListener("keydown", this.keyPressHandler, false);
  }

  closePopup() {
    const iframe = this.shadowRoot.querySelector('iframe');
    const container = this.shadowRoot.querySelector('.iframe-popup');
    document.body.classList.remove('no-scroll');

    if (container) {
      container.classList.remove('open');
    }

    if (iframe) {
      iframe.remove();
    }
  }

  keyPressHandler(event) {
    if (event.key === "Escape") {
      const iframePopups = document.querySelectorAll('hf-iframe-popup');
      iframePopups.forEach((node) => node.closePopup());
    }
  }

  openPopup() {
    const container = this.shadowRoot.querySelector('.iframe-popup');
    const iframe = document.createElement('iframe');
    container.classList.add('open');
    iframe.className = 'iframe-popup__iframe';
    iframe.src = this.url;
    iframe.width = '100%';
    iframe.height = '100%';
    container.appendChild(iframe);
    document.body.classList.add('no-scroll');
  }

  render() {
    return html`
      <div class="iframe-popup">
        <hf-icon
          @click="${this.closePopup}"
          name="close"
          class="iframe-popup__close" color="white"></hf-icon>
        <hf-button @click="${this.openPopup}">
          ${this.buttonText}
        </hf-button>
      </div>
    `;
  }
}
customElements.define('hf-iframe-popup', IframePopup);
